import { render, staticRenderFns } from "./assessors.vue?vue&type=template&id=8ce5ee9e&scoped=true"
import script from "./assessors.vue?vue&type=script&lang=js"
export * from "./assessors.vue?vue&type=script&lang=js"
import style0 from "./assessors.vue?vue&type=style&index=0&id=8ce5ee9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce5ee9e",
  null
  
)

export default component.exports